const STAGING_DOMAIN = "https://iknow.jcsoftwaresolution.in/";
const LIVE_DOMAIN = "https://iknow.jcsoftwaresolution.in/";

let apiUrl =
  process.env.REACT_APP_API || "https://iknowapi.jcsoftwaresolution.in/";
if (
  typeof window !== "undefined" &&
  (window.location.href.includes("jcsoftwaresolution") ||
    window.location.href.includes("localhost") ||
    window.location.href.includes("74.208.13.142"))
) {
  apiUrl = "https://iknowapi.jcsoftwaresolution.in/";
}
const environment = {
  api: apiUrl,
  server_url: apiUrl,
  chatbot_api: apiUrl,
  user_role_id: "6996bdbee63505b3e36d1567",
  DB_NAME: "ShopCartDB",
  STORE_NAME: "cart",
  DB_VERSION: 1,
  staging_domain: STAGING_DOMAIN,
  live_domain: LIVE_DOMAIN,
  base_domain: "iknow.jcsoftwaresolution.in",
  legacy_domain: "charlessmithassociates.com",
};

export default environment;

